module.exports = __webpack_public_path__ + "static/media/25.48735d01.jpg";